import { Button, Description, RefreshIcon, Text, dialogService } from '@thefarmersfront/kitchen-mobile';

import { EmptyText } from '~/components/shared';

import styles from './EntryErrorFallback.module.scss';

/**
 * @description 앱 진입(Entry) 화면에서 진입 조건 API 호출이 실패했을 때 노출하는 에러 화면
 */
const EntryErrorFallback = ({ error }: { error?: unknown }) => {
  const formattedError = error instanceof Error ? error : new Error(String(error));

  return (
    <div className={styles['entry-error-container']}>
      <EmptyText text="예기치 못한\n에러가 발생했어요" />
      <div className={styles['button-group']}>
        <Button
          color="tertiary"
          size="medium"
          onClick={() => {
            dialogService.addDialog({
              title: '에러 확인',
              className: styles['entry-error-dialog'],
              open: true,
              children: (
                <>
                  <Text color="secondary">불편을 끼쳐 드려 죄송합니다.</Text>
                  <Text color="secondary">
                    해당 화면을 담당자에게 전달해 주시면 보다 신속하게 도움을 드릴 수 있습니다.
                  </Text>
                  <div style={{ marginTop: '8px', width: '100%' }} />
                  <Description
                    contents={[formattedError?.name, formattedError?.message]}
                    color="error"
                    showBullet={false}
                  />
                </>
              ),
              confirmText: '확인',
            });
          }}
        >
          에러 확인
        </Button>
        <Button size="medium" leftIcon={<RefreshIcon size={16} />} onClick={() => window.location.reload()}>
          새로고침
        </Button>
      </div>
    </div>
  );
};

export default EntryErrorFallback;
